import React from 'react';
import { Nav } from 'react-bootstrap';

/**
 * The AI Admin section selector: which AI area you are looking at.
 *
 * UNDERLINE TABS, under the page's heading — an active item marked by a rule
 * beneath it, on a hairline that runs the width of the row.
 *
 * They were pills, to stay visually clear of the `variant="tabs"` Nav the
 * Knowledge Bases area renders inside itself (Documents / Retrieval / Ask):
 * two identical-looking tab bars stacked would read as one confused row.
 * That reasoning still holds and the underline keeps it — Bootstrap's
 * `nav-tabs` draws boxed tabs joined to a border, and an underline is not
 * that. So the two levels stay visibly different levels while this one
 * matches the design.
 *
 * ── RENDERS NOTHING FOR A SINGLE AREA ──
 * A selector offering one choice is not a selector, it is a bug report: a
 * lone tab reads as "the other tabs failed to load". So while exactly one
 * area is registered this returns null and the area's own heading is the
 * heading. The moment a second area lands in areas.js the selector appears
 * by itself — the seam is this component, already written and tested, not a
 * promise to build one later.
 */
function AiAreaNav({ areas, activeKey, onSelect }) {
  if (!areas || areas.length <= 1) return null;

  return (
    <Nav
      role="tablist"
      aria-label="AI Admin areas"
      activeKey={activeKey}
      onSelect={(key) => key && onSelect(key)}
      className="ai-area-nav"
    >
      {areas.map((area) => (
        <Nav.Item key={area.key}>
          <Nav.Link eventKey={area.key}>
            <i className={`fa ${area.icon} me-2`} aria-hidden="true" />
            {area.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}

export default AiAreaNav;
